/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:37:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 15:52:53                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * AdminInterventionsTab: Admin interventions tab
*/

/* Imports */
import { useCallback, useEffect, useState } from "react";
/***/

/* Services */
import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import { createListQuery, searchWithFilters } from "../../../../../../services/api/search";
import { api } from "../../../../../../services/api/api";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import WorkorderTypeForm from "../../../../../../components/data/workorder-type/WorkorderTypeForm";
import WorkorderTypeListItem from "../../../../../../components/data/workorder-type/WorkorderTypeListItem";
/***/

/**
* AdminInterventionsTab: Admin interventions tab
*/
export default function AdminInterventionsTypesTab() {
  const [types, setTypes] = useState<EasyTech.WorkorderType[] | null>(null);
  const [services, setServices] = useState<EasyTech.Service[]>([]);

  const TABLE_HEAD = [
    {
      label: "Label",
      orderKey: "label"
    }, {
      label: "Service 1",
      orderKey: "service1Id"
    }, {
      label: "Service 2",
      orderKey: "service2Id"
    }, {
      label: "Active",
      orderKey: "enabled"
    }, {
      label: "actions",
      orderKey: null
    }
  ];

  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const createType = (type: EasyTech.WorkorderType): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (type.translations) {
        type.translations = type.translations.filter((el: EasyTech.Translation) => {
          const cond = !el.label;
          return !cond;
        });
      }
      if (type && type.label) {
        api.post("admin/workorder_types", type).then((ret) => {
          loadWorkordersType();
          toast.success("Intervention types created");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la création du type d'intervention" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  const loadWorkordersType = useCallback(() => {
    searchWithFilters<EasyTech.WorkorderType>("workorder_types", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, true)
      .then(ret => setTypes(ret.data as EasyTech.WorkorderType[]))
      .catch(err => {
        console.error(err);
        setTypes([]);
      });
  }, []);

  const loadServices = useCallback(() => {
    searchWithFilters<EasyTech.Service>("services", {
      queries: []
    }, true, true)
      .then(ret => setServices(ret.data as EasyTech.Service[]))
      .catch(err => console.error(err));
  }, []);

  /**
  * useEffect: get interventions list 
  * on init
  */
  useEffect(() => {
    loadWorkordersType();
    loadServices();
  }, [loadWorkordersType, loadServices]);
  /***/

  return (
    <div>
      <div className="icon-buttons flex gap-2">
        <EditCreateDrawer data={({ translations: [] as EasyTech.Translation[] } as EasyTech.WorkorderType)}
          entityName="Intervention type"
          FormComponent={WorkorderTypeForm}
          isNotEditable={true}
          onSubmit={createType}
          createButtonText="Create new Intervention type" />
      </div>

      <div className="my-6">
        {types ?
          <Table tableHead={TABLE_HEAD}
            emptyTable={(!types || types.length === 0) ? "No types" : false}>
            {types.map((lang, index) => (
              <WorkorderTypeListItem
                key={lang.id + "-" + index}
                type={lang}
                services={services}
                isLast={index === types.length - 1}
                onChange={loadWorkordersType}
              />
            ))}
          </Table>
          : <Loading />}
      </div>

    </div>
  );
}
/***/
